// /pmo/add-label
// projectUuid
// projectLabelName
// projectLabelDescription

// service/task/api/createTask.ts
import axiosInstance from "../../axiosInstance";
import { normalizeApiError } from "utils/normalizeApiError";

interface CreateTaskLabelPayload {
    projectUuid:string;
    projectLabelName:string;
    projectLabelDescription:string
}
interface CreateTaskLabelApiResponse{}
interface LabelSuccessResponse {
    response:CreateTaskLabelApiResponse
}

export const createTaskLabel = async (
  payload: CreateTaskLabelPayload
)=> {
  try {
    const { data } = await axiosInstance.post(
      "/pmo/add-label",
      payload
    );
    

    // if (data.response.status === false) {
    //   throw data;
    // }

    return data;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
